import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

const script = () => {
	// Team slider
	new Swiper('.tpl-salon .team .swiper-container', {
		slidesPerView: 'auto',
		releaseOnEdges: true,
		forceToAxis: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		grabCursor: true,
	})

	// Brands slider
	new Swiper('.tpl-salon .brands .swiper-container', {
		slidesPerView: 1,
		grabCursor: true,
		loop: true,
		autoplay: {
			delay: 3000,
		},
		speed: 1000,
		breakpoints: {
			// when window width is <= 640px
			1023: {
				slidesPerView: 4,
			},
		},
	})
}

exports.script = script
